"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIModalDialog = _interopRequireDefault(require("UIComponents/dialog/UIModalDialog"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _HubspotUrls = _interopRequireDefault(require("../constants/HubspotUrls"));

var _ProviderSignupFields = _interopRequireDefault(require("../constants/providerSignup/ProviderSignupFields"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _SaveButton = _interopRequireDefault(require("./SaveButton"));

var _utils = require("../utils/utils");

var _default = _react.default.createClass({
  displayName: "ProviderSignupPage",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    onProviderSignupFieldChange: _react.PropTypes.func.isRequired,
    onClickErrorModalClose: _react.PropTypes.func.isRequired,
    providerSignup: _react.PropTypes.object.isRequired,
    submitProviderSignupForm: _react.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      legalAgreementChecked: false
    };
  },
  handleLegalAgreementChecked: function handleLegalAgreementChecked(event) {
    this.setState({
      legalAgreementChecked: event.target.checked
    });
    return;
  },
  getProviderSignupFieldChangeHandler: function getProviderSignupFieldChangeHandler(field, event) {
    return this.props.onProviderSignupFieldChange(field, event.target.value);
  },
  passwordFieldsMatch: function passwordFieldsMatch(providerSignup) {
    return providerSignup.get(_ProviderSignupFields.default.PASSWORD) === providerSignup.get(_ProviderSignupFields.default.PASSWORD_CONFIRMATION);
  },
  renderErrorModal: function renderErrorModal(onClickErrorModalClose, fieldsWithErrors) {
    return _react.default.createElement(_UIModalDialog.default, {
      width: 350
    }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: onClickErrorModalClose
    }), _react.default.createElement(_H.default, {
      className: "m-all-0"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.errorModal.header"
    }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.errorModal.bodyHeader"
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: (0, _utils.getProviderSignupErrorMessagePath)(fieldsWithErrors)
    }))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
      onClick: onClickErrorModalClose,
      use: "primary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.errorModal.button"
    }))));
  },
  renderErrorModalIfFailedSubmission: function renderErrorModalIfFailedSubmission() {
    var _this$props = this.props,
        onClickErrorModalClose = _this$props.onClickErrorModalClose,
        providerSignup = _this$props.providerSignup;

    if (providerSignup.get('submissionRequestStatus') === _RequestStatusTypes.default.FAILED) {
      return this.renderErrorModal(onClickErrorModalClose, providerSignup.get('fieldsWithErrors'));
    }

    return null;
  },
  renderProviderSignupForm: function renderProviderSignupForm(providerSignup, onProviderSignupFieldChange, submitProviderSignupForm) {
    return _react.default.createElement("div", {
      className: "well"
    }, _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.firstName"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.FIRST_NAME),
      value: providerSignup.get(_ProviderSignupFields.default.FIRST_NAME)
    })), _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.lastName"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.LAST_NAME),
      value: providerSignup.get(_ProviderSignupFields.default.LAST_NAME)
    })), _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.contactEmail"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.CONTACT_EMAIL),
      value: providerSignup.get(_ProviderSignupFields.default.CONTACT_EMAIL)
    })), _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.website"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.WEBSITE),
      value: providerSignup.get(_ProviderSignupFields.default.WEBSITE)
    })), _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.password"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.PASSWORD),
      type: "password",
      value: providerSignup.get(_ProviderSignupFields.default.PASSWORD)
    })), _react.default.createElement("div", {
      className: "m-top-5 m-bottom-5"
    }, _react.default.createElement("h6", null, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.fieldHeaders.confirmPassword"
    })), _react.default.createElement(_UITextInput.default, {
      maxLength: 100,
      onChange: this.partial(this.getProviderSignupFieldChangeHandler, _ProviderSignupFields.default.PASSWORD_CONFIRMATION),
      type: "password",
      value: providerSignup.get(_ProviderSignupFields.default.PASSWORD_CONFIRMATION)
    })), _react.default.createElement("div", {
      className: "m-bottom-5"
    }, _react.default.createElement(_UICheckbox.default, {
      onChange: this.partial(this.handleLegalAgreementChecked)
    }, _react.default.createElement("span", {
      className: "legal-agreement-message"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: 'providerSignup.legalAgreement',
      options: {
        link: _HubspotUrls.default.TERMS_OF_SERVICE
      }
    })))), _react.default.createElement(_UIGrid.default, {
      className: "m-bottom-5"
    }, _react.default.createElement(_UIGridItem.default, {
      size: {
        xs: 8
      }
    }, _react.default.createElement(_SaveButton.default, {
      buttonState: (0, _utils.getButtonState)(providerSignup.get('submissionRequestStatus')),
      disabled: !providerSignup.get('firstName') || !providerSignup.get('lastName') || !providerSignup.get('contactEmail') || !providerSignup.get('website') || !providerSignup.get('password') || !this.passwordFieldsMatch(providerSignup) || !this.state.legalAgreementChecked,
      onClick: submitProviderSignupForm,
      textPath: "providerSignup"
    })), _react.default.createElement(_UIGridItem.default, {
      className: "cancel-button-container",
      size: {
        xs: 4
      }
    }, _react.default.createElement(_UIButton.default, {
      href: _HubspotUrls.default.DEVELOPERS
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.cancelButton"
    })))));
  },
  render: function render() {
    var _this$props2 = this.props,
        onProviderSignupFieldChange = _this$props2.onProviderSignupFieldChange,
        providerSignup = _this$props2.providerSignup,
        submitProviderSignupForm = _this$props2.submitProviderSignupForm;
    return _react.default.createElement("div", {
      className: "provider-signup-container"
    }, _react.default.createElement(_NavMarker.default, {
      name: "PROVIDER_SIGNUP_LOAD"
    }), this.renderErrorModalIfFailedSubmission(), _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center",
      className: "m-top-10"
    }, _react.default.createElement(_UIImage.default, {
      src: _HubspotUrls.default.HUBSPOT_LOGO,
      alt: "HubSpot",
      width: 125
    }), _react.default.createElement(_H.default, {
      className: "m-left-5 m-bottom-0"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "providerSignup.pageHeader"
    }))), this.renderProviderSignupForm(providerSignup, onProviderSignupFieldChange, submitProviderSignupForm));
  }
});

exports.default = _default;
module.exports = exports.default;